import {gql} from "@apollo/client";

const DELETE_SERVICE = gql`
mutation deleteService ($id:ID!){
  clubmate {
    deleteClubmateservice (id: $id){
      message
      ok
    }
  }
}
`

const UPSERT_SERVICE=gql`
mutation upsertService ($input: ClubMateServiceMutationInput!) {
  clubmate {
    upsertClubmateservice(input: $input) {
      clubMateService{
        id
      }
      errors{
        messages
      }
    }
  }
}
`

const QUERY_SERVICE_AREA_LIST=gql`
query serviceArea($serviceId: bigint!) {
  clubmate_clubmatearea_clubmatearea(where: {clubmateservice_serviceareas: {clubmateservice_clubmateservice: {id: {_eq: $serviceId}}}}){
    id
    name
  }
}
`

const UNARCHIVE_SERVICE = gql`
mutation UnarchiveService($id: bigint!) {
  update_clubmate_clubmateservice_clubmateservice_by_pk(
    pk_columns: { id: $id }
    _set: { archive: false }
  ) {
    id
    archive
  }
}
`

const QUERY_SERVICE_GROUPS_LIST = gql`
query ServiceGroupsList {
  clubmate_clubmateservice_clubmateservicegroup {
    id
    name
  }
}
`

const INSERT_SERVICE_GROUP = gql`
mutation InsertServiceGroup($name: String!) {
  insert_clubmate_clubmateservice_clubmateservicegroup_one(
    object: { name: $name }
  ) {
    id
    name
  }
}
`

const UPDATE_SERVICE_GROUP = gql`
mutation UpdateServiceGroup($id: bigint!, $name: String!) {
  update_clubmate_clubmateservice_clubmateservicegroup_by_pk(
    pk_columns: { id: $id }
    _set: { name: $name }
  ) {
    id
    name
  }
}
`

const DELETE_SERVICE_GROUP = gql`
mutation DeleteServiceGroup($id: bigint!) {
  delete_clubmate_clubmateservice_clubmateservicegroup_by_pk(
    id: $id
  ) {
    id
  }
}
`

export {UPSERT_SERVICE, DELETE_SERVICE,QUERY_SERVICE_AREA_LIST, UNARCHIVE_SERVICE, QUERY_SERVICE_GROUPS_LIST, INSERT_SERVICE_GROUP, UPDATE_SERVICE_GROUP, DELETE_SERVICE_GROUP}

